import { render, staticRenderFns } from "./WidgetCA.vue?vue&type=template&id=21574885"
import script from "./WidgetCA.vue?vue&type=script&lang=js"
export * from "./WidgetCA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports